import axios from "axios";
import { API } from "../constants/api";
import { axiosGetWithToken, axiosPostWithoutBody, axiosPostWithToken, axiosPut } from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";

export const GET_JOB_LISTING = "GET_JOB_LISTING";
export const JOB_LIST_LOADER = "JOB_LIST_LOADER";
export const SET_JOB_ITEMS_PER_PAGE = "SET_JOB_ITEMS_PER_PAGE";
export const CHANGE_CURRENT_JOB_PAGE = "CHANGE_CURRENT_JOB_PAGE";
export const SEARCH_JOBS = "SEARCH_JOBS";
export const JOB_STATUS = "JOB_STATUS";
export const JOB_STATUS_FILTER = "JOB_STATUS_FILTER";
export const EDIT_JOB_DETAILS = "EDIT_JOB_DETAILS";
export const SCHEDULE_INTERVIEW = "SCHEDULE_INTERVIEW";
export const UPDATE_FEEDBACK = "UPDATE_FEEDBACK";
export const CANDIDATE_JOB_STATUS = "CANDIDATE_JOB_STATUS";
export const RESET_CANDIDATE_JOB_STATUS = "RESET_CANDIDATE_JOB_STATUS";
export const ASSET_URL = "ASSET_URL";
export const NOTIFY_NEXT_CANDIDATES = "NOTIFY_NEXT_CANDIDATES";
export const NOTIFY_NEXT_CANDIDATES_SUCCESS = "NOTIFY_NEXT_CANDIDATES_SUCCESS";
export const JOB_DETAILS = "JOB_DETAILS"

export const getJobListing = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: JOB_LIST_LOADER,
    });

    const token = getState().auth.token;
    const pageNumber = getState().jobs.jobListCurrentPage;
    const searchText = getState().jobs.jobListSearchText;
    const statusus = getState().jobs.jobStatusFliter;

    const bodyData = {
      search: searchText,
      page_no: pageNumber,
    };
    // Add only one of the status keys if any status filter is applied
    if (statusus.length === 1) {
      bodyData.status = String(statusus[0]);
    } else if (statusus.length > 1) {
      bodyData.statusus = statusus.map(String);
    }

    axiosPostWithToken(`${API.JOB_LISTING}`, bodyData, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: GET_JOB_LISTING,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (err && err.response && err.response.data) ||
            "Something went wrong.",
        });
      });
  };
};

export const setItemsPerPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: JOB_LIST_LOADER,
    });
    dispatch({
      type: SET_JOB_ITEMS_PER_PAGE,
      payload: value,
    });
  };
};

export const changeCurrentPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: JOB_LIST_LOADER,
    });
    dispatch({
      type: CHANGE_CURRENT_JOB_PAGE,
      payload: value,
    });
  };
};

export const search = (value) => {
  return async (dispatch) => {
    dispatch({
      type: JOB_LIST_LOADER,
    });
    dispatch({
      type: SEARCH_JOBS,
      payload: value,
    });
  };
};

export const getJobStatusus = () => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    axiosGetWithToken(`${API.JOB_STATUS}`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: JOB_STATUS,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (err && err.response && err.response.data) ||
            "Something went wrong.",
        });
      });
  };
};

export const editJobDetails = (id, data, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosPostWithToken(`${API.EDIT_JOB_DETIALS}/${id}`, data, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: JOB_LIST_LOADER,
          });
          refresh();
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Job details updated Successfully",
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Error updating User.",
          });
        }
      }
    );
  };
};

export const setJobStatusFliter = (value) => {
  return async (dispatch) => {
    dispatch({
      type: JOB_STATUS_FILTER,
      payload: value,
    });
  };
};

export const scheduleInterview = (id, data) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosPostWithToken(`${API.Job_INTERVIEW_SCHEDULE}/${id}`, data, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: JOB_LIST_LOADER,
          });
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Interview Updated Successfully",
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Error updating User.",
          });
        }
      }
    );
  };
};

export const candidateJobStatus = (id, data) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    try {
      const res = await axiosPostWithToken(
        `${API.CANDIDATE_JOB_STATUS}/${id}`,
        data,
        token
      );
      if (res.status === 200) {
        dispatch({
          type: CANDIDATE_JOB_STATUS,
          payload: res.data,
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data?.message ||
            "Something went wrong. Error updating User.",
        });
      }
    } catch (err) {
      dispatch({
        type: ERROR_ALERT,
        payload: "Something went wrong while calling the API.",
      });
    }
  };
};

export const updateFeedBack = (
  jobId,
  candidate,
  status,
  joining_date,
  comments,
  attachment
) => {
  const data = {
  candidate,
  job: jobId,
  status, // 4 if rejected, 3 for selected
  comments,
  ...(status !== 4 && joining_date ? { joining_date } : {}),
  ...(attachment?.url ? { attachment: attachment.url } : {})
};

  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosPostWithToken(`${API.FEEDBACK_STATUS}`, data, token).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: JOB_LIST_LOADER,
        });
        dispatch({
          type: SUCCESS_ALERT,
          payload: res.data.data.message || "Feedback Updated Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Error updating User.",
        });
      }
    });
  };
};

export const resetCandidateJobStatus = () => ({
  type: RESET_CANDIDATE_JOB_STATUS,
});

export const uploadFeedbackFile = (file) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(API.ASSET_UPLOAD, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status_code === 200) {
        const fileUrl = response.data.data.url;

        dispatch({ type: ASSET_URL, payload: fileUrl });
        dispatch({
          type: SUCCESS_ALERT,
          payload: "File uploaded successfully",
        });

        return fileUrl; //  return so component can use it
      }
    } catch (error) {
      dispatch({
        type: ERROR_ALERT,
        payload: "An error occurred while uploading the file.",
      });
      throw error;
    }
  };
};


export const sendNotification = (id) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
       dispatch({ type: NOTIFY_NEXT_CANDIDATES });
    axiosPostWithoutBody(`${API.NOTIFY_NEXT_CANDIDATES}/${id}`, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: res.data.data?.message,
          });
           dispatch({ type: NOTIFY_NEXT_CANDIDATES_SUCCESS });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Error updating User.",
          });
        }
      }
    );
  };
};

export const rejectSelectedCandidate = (id, candidate) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosGetWithToken(`${API.REJECT_SELECTED_CANDIDATE}/${id}/${candidate}`, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: res.data.data?.message,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Error updating User.",
          });
        }
      }
    );
  };
};


export const jobDetails = (id) =>{
    return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosGetWithToken(`${API.JOB_DETAILS}${id}`, token).then(
      (res) => {
        if (res.data.status_code === 200) {
         dispatch({
            type: JOB_DETAILS,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Error updating User.",
          });
        }
      }
    );
  };
} 

export const companyExclude = (id, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosPut(`${API.COMPANY_EXCLUDE}${id}`, {},token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: res.data.data?.message,
          });
          refresh()
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Error updating User.",
          });
        }
      }
    );
  };
};


export const addCandidate = (id, payload) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosPostWithToken(`${API.ADD_CANDIDATES}${id}`, payload, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: res.data.data?.message,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Error updating User.",
          });
        }
      }
    );
  };
};
